import { z } from 'zod';

export const commonTextInputMin = 1;
export const commonTextInputMax = 255; // Maximum number of characters in an 8-bit number

const commonTextInputMinSchema = z.string().min(commonTextInputMin, {
  message: 'Must not be blank'
});

const commonTextInputMaxSchema = z.string().max(commonTextInputMax, {
  message: `Must not exceed ${commonTextInputMax} characters`
});

const trimmedStringSchema = z.string().trim();

export const commonRequiredTextInputSchema = trimmedStringSchema
  .pipe(commonTextInputMinSchema)
  .pipe(commonTextInputMaxSchema);

export const commonOptionalTextInputSchema = trimmedStringSchema.pipe(commonTextInputMaxSchema);
